import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  NgZone,
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../../../environments/environment";
import { CommonHttpService } from "../../commonHttp.service";
import { LoaderService } from "../../../_shared/services/loader.service";
import { AddToCartService } from "../../../_shared/services/add-to-cart.service";
import "rxjs/add/operator/map";
import "rxjs/add/operator/first";
import { } from "jquery";
import "rxjs/add/operator/filter";
declare var $;
declare var $Jease$;
declare var $JssorArrowNavigator$;
declare var $JssorBulletNavigator$;
declare var $JssorSlider$;

@Component({
  selector: "app-top-sellings",
  templateUrl: "./top-sellings.component.html",
  styleUrls: ["./top-sellings.component.css"],
})
export class TopSellingsComponent implements OnInit {
  isavailable = false;
  utm_source: string;
  products: any = [];
  beautyhygin: any = [];
  homekitchwn: any = [];
  slidingbanner: any = [];
  breckfastsnk: any = [];
  cleaninghousehold: any = [];
  baseUrl: any = environment.apiUrl;
  imageUrl: any = environment.imageUrl;
  sendData: any = {};
  cart: any = {};
  cartItems: any = [];
  quantityError: boolean = false;
  availableQuantity: number;
  showLoaderProduct: boolean = false;
  middleBanners: any = [];
  bottomBanners: any = [];
  products1: any = [];
  products2: any = [];
  topSellingStock: any = [];
  allHeaderData: any = []
  brandImages: any = []
  @ViewChild("#slider2_container") selectRef: ElementRef;

  constructor(
    private service: CommonHttpService,
    private addToCartService: AddToCartService,
    private router: Router,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private ngZone: NgZone
  ) {
    this.addToCartService.isCartChanged.subscribe((flag) => {
      this.cart = JSON.parse(localStorage.getItem("cart"));
      this.cartItems = this.cart != null ? this.cart.EcartItem : [];
      this.updateCart();
    });
  }
  ngOnInit() {
    this.getAllCategoryHeader();
    setTimeout(() => {
      if (window.screen.width > 480) {
        $("#topselleing").owlCarousel({
          autoPlay: 2000, //Set AutoPlay to 3 seconds
          navigation: true,
          items: 5,
          itemsDesktop: [1199, 3],
          itemsDesktopSmall: [979, 3],
        });
      } else {
        $("#topselleing").owlCarousel({
          autoPlay: 2000, //Set AutoPlay to 3 seconds
          navigation: false,
          items: 5,
          itemsDesktop: [1199, 3],
          itemsDesktopSmall: [979, 3],
        });
      }

      $("#lastbanner").owlCarousel({
        autoPlay: 2500, //Set AutoPlay to 3 seconds
        //   navigation: true,
        items: 1,
        itemsDesktop: [1199, 3],
        itemsDesktopSmall: [979, 3],
      });
    }, 2000);
    setTimeout(() => {
      $("#brandcowlcarousel").owlCarousel({
        autoPlay: 2500, //Set AutoPlay to 3 seconds
        items: 6,
        itemsDesktop: [1199, 3],
        itemsDesktopSmall: [979, 3],
      });
    }, 1700);
    // $(window).on("load", function () {
    //   $("#topselleing").owlCarousel({
    //     autoPlay: 3000, //Set AutoPlay to 3 seconds
    //     navigation: true,
    //     items: 5,
    //     itemsDesktop: [1199, 3],
    //     itemsDesktopSmall: [979, 3],
    //   });
    // });
    // $(window).on("load", function () {
    //   $("#brandcowlcarousel").owlCarousel({
    //     autoPlay: 2500, //Set AutoPlay to 3 seconds
    //     //    navigation: true,
    //     items: 6,
    //     itemsDesktop: [1199, 3],
    //     itemsDesktopSmall: [979, 3],
    //   });
    // });
    // $(window).on("load", function () {
    //   $("#lastbanner").owlCarousel({
    //     autoPlay: 2500, //Set AutoPlay to 3 seconds
    //     //   navigation: true,
    //     items: 1,
    //     itemsDesktop: [1199, 3],
    //     itemsDesktopSmall: [979, 3],
    //   });
    // });
    console.log(JSON.parse(localStorage.getItem("utm_sources")));
    this.route.queryParams
      .filter((params) => params.utm_source)
      .subscribe((params) => {
        console.log(params); // {order: "popular"}
        console.log(params.utm_source);
        if (params.utm_source != undefined) {
          this.isavailable = true;
        }
        this.utm_source = params.utm_source;
      });
    console.log(this.utm_source);
    this.cart = JSON.parse(localStorage.getItem("cart"));
    this.cartItems = this.cart != null ? this.cart.EcartItem : [];
    setTimeout(() => {
      this.loadData();
    }, 1);
    this.getMiddleBanners();
    this.getBottomBanners();
  }
  getAllCategoryHeader() {
    //BannerNewAPI/GetAllDtoreFrontBannerName/
    this.service
      .get(this.baseUrl + "BannerNewAPI/GetAllDtoreFrontBannerName/")
      .subscribe((data) => {
        console.log(data);

        this.allHeaderData = data
        this.allHeaderData.reverse()

      });
  }
  getMiddleBanners() {
    this.service
      .get(this.baseUrl + "SliderAPI/GetMiddleSliderBanners")
      .subscribe(
        (data) => {
          console.log(data);
          this.middleBanners = data;
          this.ngZone.onMicrotaskEmpty.first().subscribe(() => {
            this.slide();
          });
        },
        (error) => { }
      );
  }

  getBottomBanners() {
    this.service.get(this.baseUrl + "SliderAPI/GetBottomBanners").subscribe(
      (data) => {
        console.log(data);
        for (var i = 0; i < data.length; i++) {
          if (i < 3) {
            this.bottomBanners.push(data[i]);
          }
        }
      },
      (error) => { }
    );
  }

  loadData() {
    this.showLoaderProduct = true;
    this.sendData = { Limit: 10, Offset: 0 };
    this.service
      .get(this.baseUrl + "SliderAPI/GetExtraSliderBanners/?id=13")
      .subscribe((data) => {
        console.log(data);
        this.beautyhygin = data;
      });
    this.service
      .get(this.baseUrl + "SliderAPI/GetExtraSliderBanners/?id=14")
      .subscribe((data) => {
        console.log(data);
        this.homekitchwn = data;
      });
    this.service
      .get(this.baseUrl + "SliderAPI/GetExtraSliderBanners/?id=15")
      .subscribe((data) => {
        console.log(data);
        this.slidingbanner = data;
      });
    this.service
      .get(this.baseUrl + "SliderAPI/GetExtraSliderBanners/?id=16")
      .subscribe((data) => {
        console.log(data);
        this.breckfastsnk = data;
      });
    this.service
      .get(this.baseUrl + "SliderAPI/GetExtraSliderBanners/?id=22")
      .subscribe((data) => {
        console.log(data);
        this.brandImages = data;
      });
    this.service
      .get(this.baseUrl + "SliderAPI/GetExtraSliderBanners/?id=17")
      .subscribe((data) => {
        console.log(data);
        this.cleaninghousehold = data;
      });
    this.service
      .get(this.baseUrl + "OfferAPI/GetTopSellingProductByStoreId")
      .subscribe(
        (data) => {
          console.log(data);
          this.products = data;
          for (var i = 0; i < this.products.length; i++) {
            for (var j = 0; j < this.topSellingStock.length; j++) {
              if (
                this.topSellingStock[j].productId == this.products[i].productId
              ) {
                this.products[i].totalStock = this.topSellingStock[
                  j
                ].totalStock;
                this.topSellingStock.splice(j, 1);
              }
            }
            // i < 10
            this.products1.push(this.products[i])
            // : this.products2.push(this.products[i]);
          }
          this.updateCart();
          this.showLoaderProduct = false;
        },
        (error) => {
          this.showLoaderProduct = false;
        }
      );
  }

  addToCart(product) {
    product.cartQuantity = 1;
    this.addToCartService.addToCart(product);
  }

  updateCart() {
    for (var i = 0; i < this.products.length; i++) {
      this.products[i].isAddedToCart = false;
    }
    for (var i = 0; i < this.cartItems.length; i++) {
      for (var j = 0; j < this.products.length; j++) {
        if (this.cartItems[i].ProductId == this.products[j].productId) {
          this.products[j].isAddedToCart = true;
          this.products[j].cartQuantity = this.cartItems[i].Quantity;
        }
      }
    }
  }

  substractquantity(product, cartQuantity, i) {
    this.quantityError = false;
    product.cartQuantity = cartQuantity - 1;
    this.addToCartService.addToCart(product);
  }

  addQuantity(product, cartQuantity, i) {
    if (cartQuantity + 1 > product.totalStock) {
      this.quantityError = true;
      this.availableQuantity = product.totalStock;
      product.cartQuantity = cartQuantity;
    } else {
      this.quantityError = false;
      product.cartQuantity = cartQuantity + 1;
    }
    this.addToCartService.addToCart(product);
  }

  onQuantityChange(product, cartQuantity, i) {
    if (cartQuantity > product.totalStock) {
      this.quantityError = true;
      this.availableQuantity = product.totalStock;
      product.cartQuantity = product.totalStock;
    } else {
      this.quantityError = false;
      product.cartQuantity = cartQuantity;
    }
    this.addToCartService.addToCart(product);
  }

  slide() {
    $(document).ready(function ($) {
      var options = {
        $AutoPlay: 1,
        $AutoPlaySteps: 1,
        $Idle: 2000,
        $PauseOnHover: 1,

        $ArrowKeyNavigation: 1,
        $SlideEasing: $Jease$.$OutQuint,
        $SlideDuration: 800,
        $MinDragOffsetToSlide: 20,
        //$SlideWidth: 600,
        //$SlideHeight: 300,
        $SlideSpacing: 0,
        $UISearchMode: 1,
        $PlayOrientation: 1,
        $DragOrientation: 1,

        $ArrowNavigatorOptions: {
          $Class: $JssorArrowNavigator$,
          $ChanceToShow: 2,
          $Steps: 1,
        },

        $BulletNavigatorOptions: {
          $Class: $JssorBulletNavigator$,
          $ChanceToShow: 2,
          $Steps: 1,
          $SpacingX: 12,
          $Orientation: 1,
        },
      };

      var jssor_slider1 = new $JssorSlider$("slider2_container", options);

      //responsive code begin
      //you can remove responsive code if you don't want the slider scales while window resizing
      function ScaleSlider() {
        var parentWidth = jssor_slider1.$Elmt.parentNode.clientWidth;
        if (parentWidth) {
          jssor_slider1.$ScaleWidth(parentWidth - 30);
        } else window.setTimeout(ScaleSlider, 30);
      }
      ScaleSlider();

      $(window).bind("load", ScaleSlider);
      $(window).bind("resize", ScaleSlider);
      $(window).bind("orientationchange", ScaleSlider);
      //responsive code end
    });
  }

  routebanner(banner) {
    localStorage.setItem("selectedItem", JSON.stringify(banner));
    this.router.navigate(["/Banner-product-all/" + banner.bannerId]);
  }

}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/home/top-sellings/top-sellings.component.ts